export default "__VITE_ASSET__BulrCYzI__"